// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__cMDXP","col":"styles_col__1zhR7"};